import TMLogo from "@/assets/images/TM-qr.png";
import jsPDF from "jspdf";
import QRCodeStyling from "qr-code-styling";

// static file names, so the download is not named after the provider
const QR_FILE_NAMES = {
  menu: "qr",
  outdoor: "qr-takeaway",
  panel: "panel-qr",
};

const DEFAULT_QR_FILE_NAME = QR_FILE_NAMES.menu;

export const createQrInstance = (url) =>
  new QRCodeStyling({
    width: 1000,
    height: 1000,
    type: "svg",
    data: url,
    margin: 29,
    qrOptions: { errorCorrectionLevel: "H" },
    image: TMLogo,
    dotsOptions: { color: "#000000", type: "rounded" },
    backgroundOptions: { color: "#ffffff" },
    cornersSquareOptions: { type: "extra-rounded", color: "#000000" },
    cornersDotOptions: { type: "extra-rounded", color: "#000000" },
    imageOptions: {
      crossOrigin: "anonymous",
      margin: 21,
      imageSize: 0.45,
      hideBackgroundDots: false,
    },
    shape: "square",
  });

/**
 * @param {string} url
 * @param {"menu" | "outdoor"} qrType
 * @param {"png" | "pdf"} exportType
 */
export const generateQr = async (url, qrType, exportType) => {
  const filename = QR_FILE_NAMES[qrType] || DEFAULT_QR_FILE_NAME;
  const qr = createQrInstance(url);
  const blob = await qr.getRawData("png");
  if (!blob) return;

  if (exportType === "png") {
    const anchor = document.createElement("a");
    anchor.href = URL.createObjectURL(blob);
    anchor.download = `${filename}.png`;
    anchor.click();
    URL.revokeObjectURL(anchor.href);
    return;
  }

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      const imgData = reader.result;
      // eslint-disable-next-line new-cap
      const pdf = new jsPDF({ unit: "px", format: [1000, 1000] });
      pdf.addImage(imgData, "PNG", 0, 0, 1000, 1000);
      pdf.save(`${filename}.pdf`);
      resolve();
    });
    reader.readAsDataURL(blob);
  });
};
